import { forwardRef } from "react";
import cx from "classnames";
import "./Radio.scss";

type RadioProps = {
  as?: string;
  id?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  subLabel?: string;
};

const Radio = forwardRef<HTMLInputElement, RadioProps>(
  (
    {
      as = "input",
      id,
      name,
      value,
      checked = false,
      disabled = false,
      onChange,
      label,
      subLabel,
    },
    ref,
  ) => {
    const radioClasses = cx("Radio", {
      "Radio--Checked": checked,
      "Radio--Disabled": disabled,
    });

    return (
      <label className={radioClasses}>
        {as === "input" && (
          <input
            ref={ref}
            type="radio"
            id={id}
            name={name}
            value={value}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
            className="Radio__Input"
          />
        )}
        <span className="Radio__Control">
          {checked && <span className="Radio__CheckIcon" />}
        </span>
        <div className="Radio__LabelContainer">
          <span className="Radio__Label">{label}</span>
          {subLabel && <span className="Radio__SubLabel">{subLabel}</span>}
        </div>
      </label>
    );
  },
);

export { Radio };
